import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ArrowIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";

import {useGetOfferGalleryQuery} from "../../../offer/api/get_offer_gallery";
import {OfferGalleryModalContent} from "../../../offer/components/gallery_holder/OfferGalleryModalContent";
import {PropertyPlanDisplay} from "../../../property/components/PropertyPlanDisplay";
import {getPropertyPlanImages} from "../../../property/helpers/get_property_plan_images";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {leadModalZindex} from "../../constants/lead/lead_modal_zindex";
import {TINDER_MULTI_LEAD_LOCATION} from "./tracking/track_tinder_multi_lead_events";

export type TinderMultiLeadMediaMode = "plan" | "gallery";

interface IProps {
    mode: TinderMultiLeadMediaMode;
    property: IPropertyDetail;
    onClose: () => void;
}

const noop = () => undefined;

export function TinderMultiLeadMediaModal({mode, property, onClose}: IProps) {
    const {data: offerGallery} = useGetOfferGalleryQuery(property.offer.id, {skip: mode !== "gallery"});

    const planSlides = property.plan_image_pages.length
        ? getPropertyPlanImages(property.plan_image_pages)
        : property.external_plan_url
          ? [{srcSm: property.external_plan_url, srcMd: property.external_plan_url, srcLg: property.external_plan_url}]
          : [];

    return (
        <Modal isOpen onModalClose={onClose} fullScreen modalTheme="dark" zIndex={leadModalZindex + 1} showCloseButton={false}>
            <Modal.Content className={contentStyle}>
                <div className={headerStyle}>
                    <Button variant="outlined_secondary_light" size="x-small" iconLeft={ArrowIcon} onClick={onClose}>
                        Powrót do szczegółów
                    </Button>
                </div>

                <div className={bodyStyle}>
                    {mode === "gallery" ? (
                        <OfferGalleryModalContent
                            offer={property.offer}
                            offerGallery={offerGallery ?? []}
                            showMainImage
                            shouldShowVideo
                            propertyId={property.id}
                            lightboxZIndex={leadModalZindex + 2}
                            amplitudeGalleryContext={{location: TINDER_MULTI_LEAD_LOCATION}}
                        />
                    ) : (
                        <PropertyPlanDisplay
                            className={planDisplayStyle}
                            property={property}
                            vendor={property.offer.vendor}
                            onPlanDownloadClick={noop}
                            showPlanDownloadButton={false}
                            legacyPlan={
                                <div className={legacyPlanStyle}>
                                    {planSlides.map((slide, index) => (
                                        <img key={index} className={legacyPlanImageStyle} src={slide.srcLg} alt={`Rzut ${property.number} ${index + 1}`} />
                                    ))}
                                </div>
                            }
                            propertyId={property.id}
                            offerId={property.offer.id}
                        />
                    )}
                </div>
            </Modal.Content>
        </Modal>
    );
}

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    p: 0,
    height: "100%",
    minHeight: 0
});

const headerStyle = css({
    display: "flex",
    justifyContent: "flex-end",
    flexShrink: 0,
    px: 2,
    py: 2,
    md: {
        px: 3
    }
});

const bodyStyle = css({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    px: 2,
    pb: 2,
    md: {
        px: 4,
        pb: 4
    }
});

const legacyPlanStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flex: 1,
    width: "100%",
    gap: 2
});

const legacyPlanImageStyle = css({
    display: "block",
    width: "100%",
    maxWidth: "1440px",
    height: "auto",
    backgroundColor: "var(--colors-white)"
});

const planDisplayStyle = css({
    flex: 1,
    width: "100%",
    minHeight: 0
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ArrowIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";

import {useGetOfferGalleryQuery} from "../../../offer/api/get_offer_gallery";
import {OfferGalleryModalContent} from "../../../offer/components/gallery_holder/OfferGalleryModalContent";
import {PropertyPlanDisplay} from "../../../property/components/PropertyPlanDisplay";
import {getPropertyPlanImages} from "../../../property/helpers/get_property_plan_images";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {leadModalZindex} from "../../constants/lead/lead_modal_zindex";
import {TINDER_MULTI_LEAD_LOCATION} from "./tracking/track_tinder_multi_lead_events";

export type TinderMultiLeadMediaMode = "plan" | "gallery";

interface IProps {
    mode: TinderMultiLeadMediaMode;
    property: IPropertyDetail;
    onClose: () => void;
}

const noop = () => undefined;

export function TinderMultiLeadMediaModal({mode, property, onClose}: IProps) {
    const {data: offerGallery} = useGetOfferGalleryQuery(property.offer.id, {skip: mode !== "gallery"});

    const planSlides = property.plan_image_pages.length
        ? getPropertyPlanImages(property.plan_image_pages)
        : property.external_plan_url
          ? [{srcSm: property.external_plan_url, srcMd: property.external_plan_url, srcLg: property.external_plan_url}]
          : [];

    return (
        <Modal isOpen onModalClose={onClose} fullScreen modalTheme="dark" zIndex={leadModalZindex + 1} showCloseButton={false}>
            <Modal.Content className={contentStyle}>
                <div className={headerStyle}>
                    <Button variant="outlined_secondary_light" size="x-small" iconLeft={ArrowIcon} onClick={onClose}>
                        Powrót do szczegółów
                    </Button>
                </div>

                <div className={bodyStyle}>
                    {mode === "gallery" ? (
                        <OfferGalleryModalContent
                            offer={property.offer}
                            offerGallery={offerGallery ?? []}
                            showMainImage
                            shouldShowVideo
                            propertyId={property.id}
                            lightboxZIndex={leadModalZindex + 2}
                            amplitudeGalleryContext={{location: TINDER_MULTI_LEAD_LOCATION}}
                        />
                    ) : (
                        <PropertyPlanDisplay
                            className={planDisplayStyle}
                            property={property}
                            vendor={property.offer.vendor}
                            onPlanDownloadClick={noop}
                            showPlanDownloadButton={false}
                            legacyPlan={
                                <div className={legacyPlanStyle}>
                                    {planSlides.map((slide, index) => (
                                        <img key={index} className={legacyPlanImageStyle} src={slide.srcLg} alt={`Rzut ${property.number} ${index + 1}`} />
                                    ))}
                                </div>
                            }
                            propertyId={property.id}
                            offerId={property.offer.id}
                        />
                    )}
                </div>
            </Modal.Content>
        </Modal>
    );
}

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    p: 0,
    height: "100%",
    minHeight: 0
});

const headerStyle = css({
    display: "flex",
    justifyContent: "flex-end",
    flexShrink: 0,
    px: 2,
    py: 2,
    md: {
        px: 3
    }
});

const bodyStyle = css({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    px: 2,
    pb: 2,
    md: {
        px: 4,
        pb: 4
    }
});

const legacyPlanStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flex: 1,
    width: "100%",
    gap: 2
});

const legacyPlanImageStyle = css({
    display: "block",
    width: "100%",
    maxWidth: "1440px",
    height: "auto",
    backgroundColor: "var(--colors-white)"
});

const planDisplayStyle = css({
    flex: 1,
    width: "100%",
    minHeight: 0
});
